export default __webpack_public_path__ + "static/media/phpmyadmin.7a7ca833.svg";